import Alpine from "alpinejs";
import "../css/main.css";

// @ts-ignore
if (!window.Alpine) {
  Alpine.start();
  // @ts-ignore
  window.Alpine = Alpine;
}

import "./lib/viewport.ts";
/** START AUTO-IMPORTED */
import "./../../public/app/themes/sp-theme/views/components/Button/Button.ts";
import "./../../public/app/themes/sp-theme/views/components/Button/SocialShare/SocialShare.ts";
import "./../../public/app/themes/sp-theme/views/components/CardFilm/CardFilm.ts";
import "./../../public/app/themes/sp-theme/views/components/Dropdown/Dropdown.ts";
import "./../../public/app/themes/sp-theme/views/components/FormationNav/FormationNav.ts";
import "./../../public/app/themes/sp-theme/views/components/Header/Header.ts";
import "./../../public/app/themes/sp-theme/views/components/Hero/FilmsSingle/FilmsSingle.ts";
import "./../../public/app/themes/sp-theme/views/components/Hero/Slider/Slider.ts";
import "./../../public/app/themes/sp-theme/views/components/Hero/Video/Video.ts";
import "./../../public/app/themes/sp-theme/views/components/Listing/Listing.ts";
import "./../../public/app/themes/sp-theme/views/components/Player/Player.ts";
import "./../../public/app/themes/sp-theme/views/components/Tabs/Tabs.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/Banner/Countdown/Countdown.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/BentoCards/BentoCards.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/BigText/BigText.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsCampus/CardsCampus.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsDoubleColumn/Card.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsDoubleColumn/CardsDoubleColumn.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsEvents/CardsEvents.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsFilms/CardsFilms.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsNews/Slider/Slider.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsObjectif/Card.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsObjectif/CardsObjectif.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsParcours/Card.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsParcours/CardsParcours.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/CardsRencontres/Slider/Slider.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/FAQ/FAQ.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/FilmsHighlights/FilmsHighlights.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/ListingEquipments/ListingEquipments.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/Logos/Logos.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/PushEncadrants/PushEncadrants.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/PushsColored/PushsColored.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/Scenes/Scene/Dot/Dot.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/Scenes/Scene/EquipmentDetails/EquipmentDetails.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/Scenes/Scene/Scene.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/SliderDoubleRow/SliderDoubleRow.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/SliderImageText/SliderImageText.ts";
import "./../../public/app/themes/sp-theme/views/flexibles/SliderImages/SliderImages.ts";
import "./../../public/app/themes/sp-theme/views/includes/widgets/magma/magma.ts";
import "./../../public/app/themes/sp-theme/views/singles/news.ts";
import "./../../public/app/themes/sp-theme/views/singles/press.ts";
import "./lib/animation/title.ts";
/** END AUTO-IMPORTED */

// Enable Vite HMR
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("[hmr] reload");
    Alpine.destroyTree(document.body);
    Alpine.initTree(document.body);
  });
}
